import React from "react";
import PropTypes, { arrayOf, string } from "prop-types";
import { useAccessControl } from "@hooks";

const AccessControl = ({
  targetRoles,
  exceptRoles,
  changeRoleRecommended,
  children,
}) => {
  const { permission } = useAccessControl(targetRoles, exceptRoles);
  if (!permission) {
    if (changeRoleRecommended)
      return <div className="recommend">{children}</div>;
    return null;
  }
  return children;
};

/* required: display name */
AccessControl.displayName = "AccessControl";

/* required: props types */
AccessControl.propTypes = {
  targetRoles: arrayOf(string),
  exceptRoles: arrayOf(string),
  changeRoleRecommended: PropTypes.bool,
  children: PropTypes.element,
};

/* required: default props */
AccessControl.defaultProps = {
  targetRoles: [],
  exceptRoles: [],
  changeRoleRecommended: false,
  children: null,
};

export { AccessControl };
